import Config from '@lib/Config'
import Log from '@lib/Log'
import { initSentry } from '@lib/Sentry'

export const Analytics = {
  init (mode: string) {
    initSentry(mode)
    this.initAmplitude()
  },

  initAmplitude: function() {
    try {
      var identify = new window.amplitude.Identify();
    } catch(err) {
      Log.warn(this, 'could not load amplitude: ' + err.message);
      return;
    }

    if (!identify || !window.amplitude) {
      Log.warn(this, 'amplitude unavailable');
      return;
    }

    Config.amplitude = Config.amplitude || {};
    // Config.amplitude.sessionId = window.amplitude.getInstance()._sessionId;

    let instanceOptions = window.amplitude.getInstance().options;
    if (instanceOptions) {
      Config.amplitude.deviceId = instanceOptions.deviceId;
      Config.amplitude.userId = instanceOptions.userId;
    } else {
      Log.warn('[Analytics] instance options unavailable, deviceId/userId not set yet');
    }

    var u_props = this.parseConfig();
    var keys = Object.keys(u_props);

    for (var i = 0; i < keys.length; i++) {
      if (u_props[keys[i]] && u_props[keys[i]] !== '') {
        identify.setOnce(keys[i], u_props[keys[i]]);
      }
    }

    window.amplitude.getInstance().identify(identify);
  },

  parseConfig: function(propertyOverrides?: Object) {
    var properties = propertyOverrides || {};
    properties["mode"] = Config.mode;
    properties["url"] = Config.url;
    properties["host"] = Config.host;
    properties["version"] = Config.version;
    properties["platform"] = Config.platform;
    properties["framework"] = Config.framework;

    if (Config.utm_campaign && Config.utm_campaign !== '') {
      properties["utm_campaign"] = Config.utm_campaign;
    }
    if (Config.utm_source && Config.utm_source !== '') {
      properties["utm_source"] = Config.utm_source;
    }
    if (Config.utm_content && Config.utm_content !== '') {
      properties["utm_content"] = Config.utm_content;
    }
    if (Config.utm_term && Config.utm_term !== '') {
      properties["utm_term"] = Config.utm_term;
    }
    if (Config.utm_medium && Config.utm_medium !== '') {
      properties["utm_medium"] = Config.utm_medium;
    }
    if (Config.utm_program && Config.utm_program !== '') {
      properties["utm_program"] = Config.utm_program;
    }

    if (Config.quiz_version && Config.quiz_version !== '') {
      properties["quiz_version"] = Config.quiz_version;
    }

    // var abTestString = Config.abTestString();
    // if (abTestString !== '')
    //   properties["test"] = abTestString;

    return properties;
  },

  /* Event Tracking Util */
  /* ------------------------------------------------- */
  log: function(event, props: Object = {}) {
    const eventProps = this.parseConfig(props);
    Log.info(this, event + ' ' + JSON.stringify(eventProps));
    try {
      window.amplitude.getInstance().logEvent(event, eventProps);
    } catch(e) {
      Log.info(this, `amplitude unavailable: ${e}`);
    }
  },

  setUserId: function(userId) {
    try {
      window.amplitude.getInstance().setUserId(userId);
      Config.amplitude.userId = userId;
      console.log(`set amplitude user id: ${userId}`);
    } catch(e) {
      Log.warn(`[Analytics] failed to set amplitude user id: ${e}`);
    }
  },

  setLeadId: function(leadId) {
    try {
      var identify = new window.amplitude.Identify().setOnce('lead_id', leadId);
      window.amplitude.getInstance().identify(identify);
      Log.info(this, 'set amplitude lead id');
    } catch(e) {
      Log.warn(this, `failed to set amplitude lead id: ${e}`);
    }
  },

  setOnceUserData: function(key, value) {
    try {
      var identify = new window.amplitude.Identify().setOnce(key, value);
      window.amplitude.getInstance().identify(identify);
      Config.amplitude[key] = value;
      Log.info(this, `set amplitude user prop | ${key}: ${value}`);
    } catch(e) {
      Log.warn(this, `failed to set amplitude user prop ${key}: ${e}`);
    }
  },

  setUserData: function(key, value) {
    try {
      var identify = new window.amplitude.Identify().set(key, value);
      window.amplitude.getInstance().identify(identify);
      Config.amplitude[key] = value;
      Log.info(this, `set amplitude user prop | ${key}: ${value}`);
    } catch(e) {
      Log.warn(this, `failed to set amplitude user prop ${key}: ${e}`);
    }
  }
}

export default Analytics;
